export class DossierGeneralInformationHelper {
  static stripHtml(html: string): string {
    const div = document.createElement('div');
    div.innerHTML = html;
    return div.textContent || div.innerText || '';
  }

  static extractDossierId(url: string): string | null {
    const match = url.match(/\/case-management\/dossier(?:\/detail)?\/([0-9a-fA-F\-]{36})/);
    return match ? match[1] : null;
  }
}
